import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { LanguageToggle } from '../components/ui/LanguageToggle';
export function Terms() {
  const {
    lang
  } = useLanguage();
  const content = lang === 'es' ? <>
        <h1 data-id="element-548">Términos de Servicio</h1>
        <p className="muted" data-id="element-549">Última actualización: 29 de mayo de 2026</p>

        <h2 data-id="element-550">1. Aceptación de los términos</h2>
        <p data-id="element-551">
          Al acceder y usar dermalipophoenix.com, usted acepta cumplir con estos
          Términos de Servicio. Si no está de acuerdo, le pedimos que no use el
          sitio.
        </p>

        <h2 data-id="element-552">2. Naturaleza del sitio</h2>
        <p data-id="element-553">
          Este sitio es informativo y está diseñado para facilitar solicitudes
          de consulta privada. La información aquí presentada NO constituye
          asesoramiento médico ni establece una relación médico-paciente.
        </p>

        <h2 data-id="element-554">3. Solicitud de consulta</h2>
        <p data-id="element-555">
          Completar nuestro formulario de consulta privada no garantiza un
          procedimiento. Cada caso es evaluado individualmente por el equipo
          médico para determinar candidatura, idoneidad y plan personalizado.
        </p>

        <h2 data-id="element-556">4. Resultados individuales</h2>
        <p data-id="element-557">
          Los resultados estéticos varían entre cada paciente según múltiples
          factores: anatomía individual, estilo de vida, edad, condición física,
          salud general y cumplimiento del plan de recuperación. No garantizamos
          resultados específicos.
        </p>

        <h2 data-id="element-558">5. Propiedad intelectual</h2>
        <p data-id="element-559">
          Todo el contenido del sitio (textos, imágenes, logotipos, diseño) es
          propiedad de DermaLipo Phoenix y está protegido por leyes de propiedad
          intelectual. Queda prohibida su reproducción sin autorización escrita.
        </p>

        <h2 data-id="element-560">6. Imágenes de pacientes</h2>
        <p data-id="element-561">
          Toda imagen de pacientes utilizada en el sitio cuenta con
          consentimiento expreso por escrito. Las imágenes representan casos
          reales pero los resultados no son garantía de outcomes futuros.
        </p>

        <h2 data-id="element-562">7. Limitación de responsabilidad</h2>
        <p data-id="element-563">
          DermaLipo Phoenix no se hace responsable por daños directos,
          indirectos, incidentales o consecuentes derivados del uso de este
          sitio. El sitio se proporciona "tal cual" sin garantías de ningún
          tipo.
        </p>

        <h2 data-id="element-564">8. Enlaces externos</h2>
        <p data-id="element-565">
          Este sitio puede contener enlaces a otros sitios. No somos
          responsables del contenido o prácticas de privacidad de sitios
          externos.
        </p>

        <h2 data-id="element-566">9. Modificaciones</h2>
        <p data-id="element-567">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios se publicarán en esta página.
        </p>

        <h2 data-id="element-568">10. Ley aplicable</h2>
        <p data-id="element-569">
          Estos términos se rigen por las leyes del Estado de Arizona, Estados
          Unidos. Cualquier disputa será resuelta en tribunales competentes de
          Maricopa County, Arizona.
        </p>

        <h2 data-id="element-570">11. Contacto</h2>
        <p data-id="element-571">
          Para preguntas sobre estos términos:{' '}
          <a href="mailto:hello@dermalipophoenix.com" data-id="element-572">
            hello@dermalipophoenix.com
          </a>
        </p>
      </> : <>
        <h1 data-id="element-573">Terms of Service</h1>
        <p className="muted" data-id="element-574">Last updated: May 29, 2026</p>

        <h2 data-id="element-575">1. Acceptance of terms</h2>
        <p data-id="element-576">
          By accessing and using dermalipophoenix.com, you agree to comply with
          these Terms of Service. If you do not agree, please do not use the
          site.
        </p>

        <h2 data-id="element-577">2. Nature of the site</h2>
        <p data-id="element-578">
          This site is informational and designed to facilitate private
          consultation requests. The information presented here does NOT
          constitute medical advice nor does it establish a physician-patient
          relationship.
        </p>

        <h2 data-id="element-579">3. Consultation request</h2>
        <p data-id="element-580">
          Completing our private consultation form does not guarantee a
          procedure. Each case is evaluated individually by the medical team to
          determine candidacy, suitability, and personalized plan.
        </p>

        <h2 data-id="element-581">4. Individual results</h2>
        <p data-id="element-582">
          Aesthetic results vary between each patient based on multiple factors:
          individual anatomy, lifestyle, age, physical condition, general
          health, and adherence to recovery plan. We do not guarantee specific
          results.
        </p>

        <h2 data-id="element-583">5. Intellectual property</h2>
        <p data-id="element-584">
          All site content (text, images, logos, design) is the property of
          DermaLipo Phoenix and is protected by intellectual property laws.
          Reproduction without written authorization is prohibited.
        </p>

        <h2 data-id="element-585">6. Patient images</h2>
        <p data-id="element-586">
          All patient images used on the site have express written consent.
          Images represent real cases but results are not a guarantee of future
          outcomes.
        </p>

        <h2 data-id="element-587">7. Limitation of liability</h2>
        <p data-id="element-588">
          DermaLipo Phoenix is not liable for direct, indirect, incidental, or
          consequential damages arising from the use of this site. The site is
          provided "as is" without warranties of any kind.
        </p>

        <h2 data-id="element-589">8. External links</h2>
        <p data-id="element-590">
          This site may contain links to other sites. We are not responsible for
          the content or privacy practices of external sites.
        </p>

        <h2 data-id="element-591">9. Modifications</h2>
        <p data-id="element-592">
          We reserve the right to modify these terms at any time. Changes will
          be posted on this page.
        </p>

        <h2 data-id="element-593">10. Governing law</h2>
        <p data-id="element-594">
          These terms are governed by the laws of the State of Arizona, USA. Any
          dispute shall be resolved in the competent courts of Maricopa County,
          Arizona.
        </p>

        <h2 data-id="element-595">11. Contact</h2>
        <p data-id="element-596">
          For questions about these terms:{' '}
          <a href="mailto:hello@dermalipophoenix.com" data-id="element-597">
            hello@dermalipophoenix.com
          </a>
        </p>
      </>;
  return <LegalLayout data-id="element-598">{content}</LegalLayout>;
}
function LegalLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <main className="min-h-screen bg-brand-cream" data-id="element-599">
      <header className="border-b border-brand-stone/50 py-6" data-id="element-600">
        <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-601">
          <Link to="/" className="flex items-baseline gap-1.5" data-id="element-602">
            <span className="text-2xl font-serif font-normal text-brand-dark" data-id="element-603">
              DermaLipo
            </span>
            <span className="text-[10px] font-medium tracking-[0.2em] uppercase text-brand-gold" data-id="element-604">
              Phoenix
            </span>
          </Link>
          <LanguageToggle data-id="element-605" />
        </div>
      </header>

      <article className="container mx-auto px-6 py-20 max-w-3xl legal-content" data-id="element-606">
        {children}
        <div className="mt-16 pt-8 border-t border-brand-stone/50" data-id="element-607">
          <Link to="/" className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/60 hover:text-brand-dark transition-colors" data-id="element-608">
            ← Home
          </Link>
        </div>
      </article>

      <style data-id="element-609">{`
        .legal-content h1 {
          font-family: 'Playfair Display', serif;
          font-weight: 300;
          font-size: 3rem;
          color: #1B1714;
          letter-spacing: -0.02em;
          margin-bottom: 0.5rem;
        }
        .legal-content h2 {
          font-family: 'Playfair Display', serif;
          font-weight: 400;
          font-size: 1.5rem;
          color: #1B1714;
          margin-top: 2.5rem;
          margin-bottom: 0.75rem;
        }
        .legal-content p, .legal-content li {
          color: rgba(27, 23, 20, 0.75);
          line-height: 1.7;
          font-weight: 300;
          margin-bottom: 0.75rem;
        }
        .legal-content ul {
          list-style: none;
          padding-left: 1rem;
        }
        .legal-content li {
          padding-left: 1.5rem;
          position: relative;
        }
        .legal-content li::before {
          content: '·';
          color: #C9A961;
          position: absolute;
          left: 0;
          font-weight: 700;
        }
        .legal-content a {
          color: #C97B63;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .legal-content a:hover {
          color: #1B1714;
        }
        .legal-content .muted {
          color: rgba(27, 23, 20, 0.4);
          font-size: 0.875rem;
          font-weight: 500;
          letter-spacing: 0.05em;
          margin-bottom: 3rem;
        }
        .legal-content strong {
          color: #1B1714;
          font-weight: 500;
        }
      `}</style>
    </main>;
}